import "./Homepage.css"

import ComicList from "../ComicList";
import {Link} from "react-router-dom";
import NewsItem from "./NewsItem";
import headerImage from "../images/news_header.png";
import noahIcon from "../images/noah_icon.png";
import burkIcon from "../images/burk_icon.png";
import tobiIcon from "../images/tobi_icon.png";
import heldIcon from "../images/held_icon.png";
import {homepageGet} from "../actions";
import {useDispatch, useSelector} from "react-redux";
import LoadingIndicator from "./LoadingIndicator";
import {useTitle} from "../useTitle";

let icons = {
  "Burk": burkIcon,
  "Tobi": tobiIcon,
  "Noah": noahIcon,
  "Held": heldIcon
};

function Homepage() {
  const homepage = useSelector(state => state.homepage);
  let dispatch = useDispatch();
  if (homepage.newsIds.length === 0 && !homepage.loading) {
    dispatch(homepageGet);
  }
  const newsItems = homepage.newsIds.map(id => homepage.newsItems[id]);

  const comics = useSelector(state => state.stories.comics["hoh"]);
  const comicList = new ComicList(comics);
  let lastComicChar = comicList.lastComicChar;
  let lastComicCharIcon = icons[lastComicChar];

  useTitle('News');

  return (
    <div>
      <div id="news_header">
        <h1><img src={headerImage} alt="News" /></h1>
        <div id="latest_comic" className={lastComicChar}>
          <Link to={'/hoh/latest'}>
            <span>Latest Page: {comics.length || ""}</span>
            <img src={lastComicCharIcon} alt={`${lastComicChar || ""} icon`} />
          </Link>
        </div>
      </div>
      {newsItems.map(newsItem =>
        <NewsItem newsItem={newsItem} key={newsItem.id} />
      )}
      <LoadingIndicator isLoading={homepage.loading} />
    </div>
  );
}

export default Homepage;